// Single source of truth for the "User Content Warning" feature copy.
// Use these constants everywhere the warning text or tooltip is rendered
// (EnterpriseSettings toggle tooltip, TriviaQuestionBlock TEXT branch,
// MessagingSurvey body, etc.) instead of hardcoding the strings inline.
// The matching backend constants live in `backend/utils/userContentWarning.js`.

export const USER_CONTENT_WARNING_TEXT =
  "Please do not share any controlled / confidential information or inappropriate language in your response.";

export const USER_CONTENT_WARNING_TOOLTIP =
  "When turned on, automatically warn users about sharing controlled / confidential information or inappropriate language in their Trivvy responses.";
